import production from './production.json';
import development from './development.json';
import local from './local.json';
var Config = /** @class */ (function () {
    function Config() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.config = {};
        this.setEnv(process.env.NODE_ENV || 'local');
    }
    Config.prototype.get = function (item) {
        return this.config[item];
    };
    Config.prototype.setEnv = function (env) {
        switch (env) {
            case 'production':
                this.config = production;
                break;
            case 'development':
                this.config = development;
                break;
            case 'local':
                this.config = local;
                break;
            default:
                this.config = local;
                break;
        }
    };
    return Config;
}());
var config = new Config();
export { config };
